function setCookie(name, value, expiry = (3600*24)) {
	document.cookie = name + "=" + (value || "")  + "; max-age=" + expiry + "; SameSite=Strict; path=/";
}

export { setCookie }